<template>
    <div class="news-list-content">
        <el-affix :z-index="maxZIndex">
            <NavBar></NavBar>
        </el-affix>

        <div class="main">
            <Breadcrumb :bread-list="breadList"></Breadcrumb>

            <div class="news-list pointer-cursor" v-for="(item,index) in newsList" :key="index" @click="goNewsDetails(item.id)">
                <div class="left">
                    <div class="title">
                        {{ item.title }}
                    </div>

                    <div class="details">
                        <div class="auth">
                            {{ $t('newsDetails.author') }} ：{{ item.author }}
                        </div>
                        <div class="time">
                            {{ $t('newsDetails.createTime') }}：{{ UtilMethods.formatDataOfPattern(item.createTime,"YYYY/MM/DD") }}
                        </div>
                    </div>
                </div>

                <div class="right">
                    <el-icon class="icon" color="#CECCCC" size="30"><ArrowRightBold /></el-icon>
                </div>
            </div>

            <Pagination v-model:current-page="currentPage" :page-size="pageSize" :total-page="totalPage" @current-page-change="onPageChange" class="page"></Pagination>
        </div>

        <Footer></Footer>
    </div>
</template>

<script lang="ts" setup>
import NavBar from '@/components/NavBar.vue';
import Breadcrumb from '@/components/Breadcrumb.vue';
import Footer from '@/components/Footer.vue';
import { UtilMethods } from '@/util/UtilMethods';
import { BreadType, NewsType } from '@/typeDefine/EntityType';
import { Action } from '@/typeDefine/CommonTypes';
import { Api } from '@/http/Api';
import { onMounted, ref, Ref } from 'vue';
import { GetNewsListResponse } from '@/typeDefine/HttpResponseType';
import Pagination from '@/components/Pagination.vue';
import { ResponseCode } from '@/http/ResponseCode';
import { dayjs } from 'element-plus';
import { router } from '@/router';

const maxZIndex: string = UtilMethods.getDOMStyleFromCSS('--max-z-index')

const breadList: BreadType[] = [
    {
        text: 'index.navBar.news'
    }
]

//当前页
const currentPage: Ref<number> = ref(1)
//页大小
const pageSize: Ref<number> = ref(10)
//总页数
const totalPage: Ref<number> = ref(0)

//新闻列表
const newsList: Ref<GetNewsListResponse['data']['news']> = ref([])

onMounted(() => requestNewsList(currentPage.value))

//请求新闻列表
const requestNewsList: Action<[number]> = async (currentPage: number) => {
    const response: GetNewsListResponse = await Api.instance.getNewsListByPage({
        startPage: currentPage
    })

    UtilMethods.showMessageToast(response,false)

    if(response.code === ResponseCode.OK) {
        newsList.value = response.data.news
        totalPage.value = response.data.totalPage

        console.log(response)
    }
}

const onPageChange: Action<[number]> = (value: number) => {
    requestNewsList(value)
}

//查看新闻详情
const goNewsDetails: Action<[id: number]> = (id) => {
    router.push({
        name: 'newsDetails',
        params: {
            id,
        }
    })
}

</script>

<style lang="css" scoped>
.news-list-content .main {
    width: 90%;
    margin: 0 auto;
}

.news-list-content .main .news-list {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    border-bottom: 1px solid #e5e5e5;
    padding: 10px 0;
}
.news-list-content .main .news-list .left .title {
    font-size: 24px;
    margin-bottom: 10px;
}
.news-list-content .main .news-list .left .details{
    display: flex;
    color: #999;
    font-size: 14px;
}
.news-list-content .main .news-list .left .details div {
    margin-right: 10px;
}
.news-list-content .main .page {
    display: flex;
    justify-content: center;
    padding: 10px 0;
}

@media (max-width: 768px) {
    .news-list-content .main .news-list .left .title {
        font-size: 20px;
    }
    .news-list-content .main .news-list .left .details{
        font-size: 12px;
    }
}
</style>